export default {
  phone: /^[0-9().\-/]+$/,
  phoneChars: /[.\-/()]/g,
  password: /^.*(?=.*[a-zA-Z])(?=.*[0-9]).*$/,
  oneLowercase: /[a-z]+/,
  oneUppercase: /[A-Z]+/,
  oneSpecial: /[@$!%*#?&_]+/,
  oneNumber: /\d+/,
};